import { Modal } from 'bootstrap';

const STORAGE_KEY = 'serenitasPopupLastShownAt';
const SESSION_KEY = 'serenitasPopupShownInSession';

function shouldShowPopup(modalElement) {
    const frequency = modalElement.dataset.popupFrequency || 'days';
    const days = parseInt(modalElement.dataset.popupDays || '7', 10);

    if (frequency === 'always') {
        return true;
    }

    if (frequency === 'session') {
        return !window.sessionStorage.getItem(SESSION_KEY);
    }

    const lastShownAt = parseInt(window.localStorage.getItem(STORAGE_KEY) || '0', 10);

    if (!lastShownAt) {
        return true;
    }

    const diff = Date.now() - lastShownAt;
    const interval = Math.max(days, 1) * 24 * 60 * 60 * 1000;

    return diff >= interval;
}

function persistPopupState(modalElement) {
    const frequency = modalElement.dataset.popupFrequency || 'days';

    if (frequency === 'session') {
        window.sessionStorage.setItem(SESSION_KEY, '1');
        return;
    }

    if (frequency === 'days') {
        window.localStorage.setItem(STORAGE_KEY, String(Date.now()));
    }
}

export function initPopupModal() {
    const popupElement = document.getElementById('serenitasPopup');

    if (!popupElement || typeof Modal === 'undefined') {
        return;
    }

    if (!shouldShowPopup(popupElement)) {
        return;
    }

    const delaySeconds = parseInt(popupElement.dataset.popupDelay || '2', 10);
    const delay = Math.max(delaySeconds, 0) * 1000;
    const popupModal = new Modal(popupElement);

    window.setTimeout(() => {
        popupModal.show();
        persistPopupState(popupElement);
    }, delay);
}